import React from 'react'
import { onClientSide } from '../../utils/utils'

const useLocalStorage = (key, defaultValue = '') => {
  const [state, setState] = React.useState(() => {
    if (!onClientSide()) return defaultValue
    let value

    try {
      value = JSON.parse(
        window.localStorage.getItem(key) || JSON.stringify(defaultValue)
      )
    } catch (e) {
      value = defaultValue
    }
    return value
  })

  React.useEffect(() => {
    if (onClientSide()) {
      window.localStorage.setItem(key, JSON.stringify(state))
    }
  }, [state, key])

  return [state, setState]
}

export default useLocalStorage
